export default "__VITE_ASSET__CSxbO5cV__"